"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tile = exports.boxBackground = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../helpers");
const View_1 = require("../View");
const helpers_2 = require("./helpers");
const types_1 = require("./types");
const boxBackground = ({ selected, hovered, willSelect, disabled, theme }) => {
    const internalWillSelect = willSelect || hovered;
    if (disabled) {
        return `background-color: ${theme.colorBackgroundNeutralLight};`;
    }
    if (internalWillSelect && selected) {
        return `background-color: ${theme.colorSelectedCellOverlay};`;
    }
    if (internalWillSelect && !selected) {
        return `background-color: ${theme.colorNotSelectedCellOverlay};`;
    }
    if (selected) {
        return `background-color: ${theme.colorHighlightDark};`;
    }
    return `background-color: ${theme.colorNotSelectedCell};`;
};
exports.boxBackground = boxBackground;
const Box = (0, styled_components_1.default)(View_1.View) `
    width: ${({ size }) => (0, helpers_2.calcTileWidth)(size)};
    height: ${helpers_1.SIZE_L};

    ${exports.boxBackground}
`;
const Tile = (_a) => {
    var { selected = false, disabled, willSelect = false, onClick, onMouseEnter, onMouseLeave, onMouseDown, onMouseUp, size = types_1.SCHEDULING_MATRIX_TILE_SIZE.m } = _a, rest = __rest(_a, ["selected", "disabled", "willSelect", "onClick", "onMouseEnter", "onMouseLeave", "onMouseDown", "onMouseUp", "size"]);
    const [active, setActive] = (0, react_1.useState)(false);
    const [hovered, setHovered] = (0, react_1.useState)(false);
    const onMouseEnterHandler = (0, react_1.useCallback)((event) => {
        setHovered(true);
        setActive(false);
        onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(event);
    }, []);
    const onMouseLeaveHandler = (0, react_1.useCallback)((event) => {
        setHovered(false);
        setActive(false);
        onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(event);
    }, []);
    const onClickHandler = () => {
        setActive(true);
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    return (react_1.default.createElement(Box, { "data-selector-id": rest['data-selector-id'], collapsable: false, size: size, selected: selected, willSelect: !active && willSelect, hovered: !active && hovered, disabled: disabled, onClick: onClickHandler, onMouseEnter: onMouseEnterHandler, onMouseLeave: onMouseLeaveHandler, onMouseDown: onMouseDown, onMouseUp: onMouseUp }));
};
exports.Tile = Tile;
exports.Tile.sizes = types_1.SCHEDULING_MATRIX_TILE_SIZE;
//# sourceMappingURL=Tile.js.map